export const A4_SHORT_SIDE_PX = 1240;
export const A4_LONG_SIDE_PX = 1754;

export const A4_SHORT_SIDE_MM = 210;
export const A4_LONG_SIDE_MM = 297;

export const A4_RATIO_LANDSCAPE = A4_LONG_SIDE_MM / A4_SHORT_SIDE_MM; // 297/210 ≈ 1.414 (wider than tall)
export const A4_RATIO_PORTRAIT = A4_SHORT_SIDE_MM / A4_LONG_SIDE_MM; // 210/297 ≈ 0.707 (taller than wide)

export const EXPORT_MAP_ID = "rana-export-map";

export const MIN_CAPTURE_AREA_SIZE = 100 as number;
